import e, { useState as t, useEffect as n } from "react";
import { Icon as a } from "../../../../general/Icon/Icon.js";
import { tip as o } from "../../../../forms/Tooltip/Tooltip.js";
import "../../../../../../node_modules/classnames/index.js";
import { OptionButton as r } from "../../../../buttons/OptionButton/OptionButton.js";
import { t as l } from "../../../../../i18/index.js";
import { Button as i } from "../../../../buttons/Button/Button.js";
import { InAppVideos as s } from "../../../InAppVideos/InAppVideos.js";
import "../../../InAppVideos/components/VideoCard.js";
function c(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, a = Array(t); n < t; n++) a[n] = e[n];
  return a;
}
function m(t) {
  var n = t.name,
    a = t.path,
    o = t.type,
    r = t.onClick;
  return "folder" === o ? e.createElement("div", {
    className: "help-items-title"
  }, n) : n === l("video-tutorials") ? e.createElement("div", null, e.createElement("div", {
    className: "help-items-row-video",
    onClick: r
  }, n)) : e.createElement("div", null, n !== l("video-tutorials") && e.createElement("a", {
    className: "help-items-row",
    onClick: r,
    href: a,
    target: "_blank"
  }, n));
}
function p(t) {
  var n = e.createElement(i, {
    onClick: t.onClick,
    autoWidth: !0,
    size: "small",
    label: l("topbar.whats-new"),
    variant: "accent",
    className: "whats-new__button"
  });
  return e.createElement("div", {
    className: "top-bar__whats-new"
  }, e.createElement("div", {
    className: "whats-new__data"
  }, t.notify && e.createElement("div", {
    className: "whats-new__notify"
  }), e.createElement("span", {
    className: "whats-new__version"
  }, t.version)), t.path ? e.createElement("a", {
    className: "whats-new__button-link",
    href: t.path,
    target: "_blank"
  }, n) : n);
}
function u(i) {
  var u,
    d,
    f,
    h = null === (d = i.whatsNewData) || void 0 === d ? void 0 : d.notify,
    b = function (e) {
      if (Array.isArray(e)) return e;
    }(u = t(!1)) || function (e, t) {
      var n,
        a,
        o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != o) {
        var r = [],
          l = !0,
          i = !1;
        try {
          for (o = o.call(e); !(l = (n = o.next()).done) && (r.push(n.value), !t || r.length !== t); l = !0);
        } catch (e) {
          i = !0, a = e;
        } finally {
          try {
            l || null == o.return || o.return();
          } finally {
            if (i) throw a;
          }
        }
        return r;
      }
    }(u, 2) || function (e, t) {
      if (e) {
        if ("string" == typeof e) return c(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        if ("Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n) return Array.from(n);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return c(e, t);
      }
    }(u, 2) || function () {
      throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }(),
    w = b[0],
    v = b[1],
    y = e.createElement("div", {
      className: "top-bar__help-button-label"
    }, e.createElement(a, {
      regular: !0,
      name: "question-circle",
      className: "top-bar__help-button-icon"
    }), h && e.createElement("div", {
      className: "top-bar__help-button-notify"
    }));
  return n(function () {
    o({
      className: "kaseya-ui-top-bar__help-button-tooltip",
      target: document.querySelector(".top-bar__help-button-label"),
      content: l("topbar.help"),
      options: {
        position: "bottom"
      }
    });
  }, []), e.createElement("div", null, e.createElement(r, {
    className: "top-bar__help-dropdown-container",
    label: y,
    arrowSize: 0,
    closeOnClickInside: !0,
    arrowPosition: "right",
    pointTo: "right",
    edgeOffset: 0
  }, null === (f = i.helpDataList) || void 0 === f ? void 0 : f.map(function (t, n) {
    return e.createElement(m, {
      key: n,
      name: t.name,
      path: t.path,
      onClick: function onClick(e) {
        return v(!!e.target.closest(".help-items-row-video")), !0;
      },
      tagColors: t.tagColors,
      dataVimeo: t.dataVimeo,
      type: t.type
    });
  }), i.whatsNewData && e.createElement(p, i.whatsNewData)), w ? e.createElement(s, {
    onClose: function onClose() {
      return v(!1);
    },
    supportSingleVideoView: !0,
    tagColors: i.tagColors,
    dataVimeo: i.dataVimeo,
    singleVideoViewSidebar: !0
  }) : e.createElement("span", null));
}
export { u as HelpItems, m as HelpItemsRow, p as WhatsNew };